import { render, staticRenderFns } from "./ProjectSelectedVersionsDifferencesView.vue?vue&type=template&id=4acf2abb&"
import script from "./ProjectSelectedVersionsDifferencesView.vue?vue&type=script&lang=js&"
export * from "./ProjectSelectedVersionsDifferencesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports